import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { AdminService } from '../services/admin.service';
@Component({
  selector: 'app-admin-chgpwd',
  templateUrl: './admin-chgpwd.component.html',
  styleUrls: ['./admin-chgpwd.component.css']
})
export class AdminChgpwdComponent implements OnInit {

  constructor(private route: ActivatedRoute, private adm : AdminService, private router: Router) { }
  clickStatus = false;
  alreadySubmit = false;

  userData = {
    employee_code : '',
    password : ''
  }


  ngOnInit() {
    //console.log(this.route.snapshot.params.employee_code);
    this.userData.employee_code = this.route.snapshot.params.employee_code;
  }

  isValid(assignL2Form,control) 
  {
   
    if((!assignL2Form.controls[control].valid && (assignL2Form.controls[control].dirty ||assignL2Form.controls[control].touched)) || (!assignL2Form.controls[control].valid && this.clickStatus))
    {
       //var errorStr = '<div class="alert alert-danger"> * ' + control+ ' is required</div>';
       var errorStr = '<div class="alert alert-danger"> * ' + 'This field is required</div>';
      return errorStr;
    }
  }

  onSubmit(assignL2Form)
  {
    this.clickStatus = true;
    if(assignL2Form.valid)
    {
     this.alreadySubmit = true;
     //console.log(this.userData);
     var setrole = this.adm.setAdminPwd(this.userData).subscribe( res => {
      localStorage.setItem('role_msg',res.message);
      this.router.navigate(['/userList']);
     })
     
      
    }
   
   
  }

}



// WEBPACK FOOTER //
// ./src/app/admin-chgpwd/admin-chgpwd.component.ts